import { useMutation } from '@apollo/client/react'
import { graphql, type ResultOf, type VariablesOf } from '@tucan/graphql'

export const MUTATION = graphql(`
  mutation deleteMeetingRecord($id: ID!) {
    status: deleteMeetingRecord(id: $id) {
      message
    }
  }
`)

export type Data = ResultOf<typeof MUTATION>
export type Variables = VariablesOf<typeof MUTATION>

export const useDeleteMeetingRecordMutation = (
  options: useMutation.Options<Data, Variables> = {}
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update

  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: 'searchMeetingInstanceRecords',
    })
    cache.gc()

    if (oldUpdate) {
      oldUpdate(cache, result, options)
    }
  }
  return useMutation<Data, Variables>(MUTATION, options)
}
